import { render, staticRenderFns } from "./Combat.vue?vue&type=template&id=b939bf48&scoped=true&"
import script from "./Combat.vue?vue&type=script&lang=js&"
export * from "./Combat.vue?vue&type=script&lang=js&"
import style0 from "./Combat.vue?vue&type=style&index=0&id=b939bf48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b939bf48",
  null
  
)

export default component.exports